document.addEventListener('DOMContentLoaded', () => {
	const buttonSubmit = document.querySelector('#register-customer .form__submit');

	const form = document.querySelector('#register-customer');
	const formData = new FormData(form);
	const inputs = {};

	for (let [key] of formData) {
		if (key.includes('customer')) {
			inputs[key] = document.getElementById(key);
		}
	}
	//Inital state button
	buttonSubmit.setAttribute('disabled', true);

	Object.keys(inputs).forEach((key) => {

		const input = inputs[key];

		//Inital state checkboxes
		inputs['customer[age]'].checked = false;

		input.oninput = () => {
			if (inputs['customer[first_name]'].value !== '' &&
                inputs['customer[last_name]'].value !== '' &&
                inputs['customer[email]'].value !== '' &&
                inputs['customer[password]'].value !== '' &&
                inputs['customer[age]'].checked == true)
			{
				buttonSubmit.removeAttribute('disabled');
			}else {
				buttonSubmit.setAttribute('disabled', true);
			}
		};
		inputs['customer[age]'].onclick = () =>{
			if (inputs['customer[age]'].checked) {
				inputs['customer[age]'].checked = true;
				inputs['customer[age]'].setAttribute('data-gtm-state', inputs['customer[age]'].checked);
				inputs['customer[age]'].style.borderColor = '#525252';
			}else {
				inputs['customer[age]'].checked = false;
				inputs['customer[age]'].setAttribute('data-gtm-state', inputs['customer[age]'].checked);
			}
		};
	});

});
